export const GET_SIGNING_VIEW = 'GET_SIGNING_VIEW'
export const GET_NDA_SIGNING_VIEW = 'GET_NDA_SIGNING_VIEW'
